/**
 * @generated SignedSource<<749745f14cb6c91d5b289948609ba965>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type identityprovidertype = "AXON" | "OIDC" | "SAML" | "UNKNOWN" | "%future added value";
export type login_type = "AXON" | "ONE_TIME_PASSWORD" | "SSO" | "UNKNOWN" | "%future added value";
export type organizationpermission = "ADMIN" | "MEMBER" | "MODERATOR" | "REMOTE_PILOT" | "SKYDIO_READONLY" | "SKYDIO_SUPERUSER" | "TESTER" | "UNKNOWN" | "%future added value";
export type resource_group_permission = "ADMIN" | "MEMBER" | "MODERATOR" | "REMOTE_PILOT" | "SKYDIO_READONLY" | "SKYDIO_SUPERUSER" | "TESTER" | "UNKNOWN" | "%future added value";
export type ResourceGroupLinkInput = {
  resourceGroupNodeId: string;
  resourceGroupPermission: organizationpermission;
};
export type enableOrganizationUsersMutation$variables = {
  connections: ReadonlyArray<string>;
  emails: ReadonlyArray<string>;
  expiry?: string | null;
  organizationId: string;
  organizationPermission?: organizationpermission | null;
  resourceGroupLinks?: ReadonlyArray<ResourceGroupLinkInput | null> | null;
};
export type enableOrganizationUsersMutation$data = {
  readonly bulkEnableOrganizationUsers: {
    readonly enabledUsers: ReadonlyArray<{
      readonly displayName: string | null;
      readonly email: string;
      readonly expiry: string | null;
      readonly firstName: string | null;
      readonly id: string;
      readonly lastName: string | null;
      readonly loginTypes: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly authEnabled: boolean;
            readonly identityProviderConfiguration: {
              readonly id: string;
              readonly name: string;
              readonly providerType: identityprovidertype;
              readonly uuid: string;
            } | null;
            readonly loginType: login_type;
          } | null;
        } | null>;
      } | null;
      readonly loginTypesOverriden: boolean | null;
      readonly organizationPermission: organizationpermission;
      readonly resourceGroupLinks: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly resourceGroupId: string;
            readonly resourceGroupName: string | null;
            readonly resourceGroupPermission: resource_group_permission;
          } | null;
        } | null>;
      } | null;
      readonly supportedLoginOptions: ReadonlyArray<{
        readonly identityProviderConfiguration: {
          readonly name: string;
          readonly providerType: identityprovidertype;
        } | null;
        readonly loginType: login_type;
      } | null> | null;
      readonly uuid: string;
      readonly " $fragmentSpreads": FragmentRefs<"UserProfile_loginTypes">;
    } | null> | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type enableOrganizationUsersMutation = {
  response: enableOrganizationUsersMutation$data;
  variables: enableOrganizationUsersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emails"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expiry"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationPermission"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceGroupLinks"
},
v6 = [
  {
    "kind": "Variable",
    "name": "emails",
    "variableName": "emails"
  },
  {
    "kind": "Variable",
    "name": "expiry",
    "variableName": "expiry"
  },
  {
    "kind": "Variable",
    "name": "organizationId",
    "variableName": "organizationId"
  },
  {
    "kind": "Variable",
    "name": "organizationPermission",
    "variableName": "organizationPermission"
  },
  {
    "kind": "Variable",
    "name": "resourceGroupLinks",
    "variableName": "resourceGroupLinks"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationPermission",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "UserResourceGroupLinkConnection",
  "kind": "LinkedField",
  "name": "resourceGroupLinks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserResourceGroupLinkEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserResourceGroupLink",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resourceGroupId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resourceGroupName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resourceGroupPermission",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loginType",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "providerType",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loginTypesOverriden",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authEnabled",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "IdentityProviderConfiguration",
  "kind": "LinkedField",
  "name": "identityProviderConfiguration",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expiry",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "enableOrganizationUsersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "BulkEnableOrganizationUsers",
        "kind": "LinkedField",
        "name": "bulkEnableOrganizationUsers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "enabledUsers",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LoginTypes",
                "kind": "LinkedField",
                "name": "supportedLoginOptions",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IdentityProviderConfiguration",
                    "kind": "LinkedField",
                    "name": "identityProviderConfiguration",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserProfile_loginTypes"
              },
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LoginTypesConnection",
                "kind": "LinkedField",
                "name": "loginTypes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LoginTypesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LoginTypes",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "enableOrganizationUsersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "BulkEnableOrganizationUsers",
        "kind": "LinkedField",
        "name": "bulkEnableOrganizationUsers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "enabledUsers",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LoginTypes",
                "kind": "LinkedField",
                "name": "supportedLoginOptions",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IdentityProviderConfiguration",
                    "kind": "LinkedField",
                    "name": "identityProviderConfiguration",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v18/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "organizationNotes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LoginTypesConnection",
                "kind": "LinkedField",
                "name": "loginTypes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LoginTypesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LoginTypes",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "enabledUsers",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "OrganizationUserEdge"
              }
            ]
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f4b4696cee3325a8a6dcf1a61d3ca8e3",
    "id": null,
    "metadata": {},
    "name": "enableOrganizationUsersMutation",
    "operationKind": "mutation",
    "text": "mutation enableOrganizationUsersMutation(\n  $organizationId: ID!\n  $emails: [String!]!\n  $organizationPermission: organizationpermission\n  $resourceGroupLinks: [ResourceGroupLinkInput]\n  $expiry: DateTime\n) {\n  bulkEnableOrganizationUsers(organizationId: $organizationId, emails: $emails, organizationPermission: $organizationPermission, resourceGroupLinks: $resourceGroupLinks, expiry: $expiry) {\n    enabledUsers {\n      id\n      email\n      uuid\n      displayName\n      firstName\n      lastName\n      organizationPermission\n      resourceGroupLinks {\n        edges {\n          node {\n            id\n            resourceGroupId\n            resourceGroupName\n            resourceGroupPermission\n          }\n        }\n      }\n      supportedLoginOptions {\n        loginType\n        identityProviderConfiguration {\n          name\n          providerType\n          id\n        }\n        id\n      }\n      ...UserProfile_loginTypes\n      loginTypesOverriden\n      loginTypes {\n        edges {\n          node {\n            loginType\n            authEnabled\n            identityProviderConfiguration {\n              id\n              name\n              providerType\n              uuid\n            }\n            id\n          }\n        }\n      }\n      expiry\n    }\n    errors\n  }\n}\n\nfragment UserProfile_loginTypes on User {\n  id\n  uuid\n  email\n  firstName\n  lastName\n  organizationPermission\n  loginTypesOverriden\n  expiry\n  organizationNotes\n  resourceGroupLinks {\n    edges {\n      node {\n        resourceGroupId\n        resourceGroupName\n        resourceGroupPermission\n        id\n      }\n    }\n  }\n  loginTypes {\n    edges {\n      node {\n        loginType\n        authEnabled\n        identityProviderConfiguration {\n          id\n          name\n          providerType\n          uuid\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0d32342e664140b62b15f38af610bab";

export default node;
